// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';

import Layout from '../components/Layout';
import TextHeader1 from '../components/TextHeader1';
import TextStrong from '../components/TextStrong';
import type { TProps } from './types';
import Container from '../components/Container';
import ButtonBlock from '../components/ButtonBlock';
import VerifiableAccount from '../lib/VerifiableAccount';
import ListItemVerifiableAccount from '../components/ListItemVerifiableAccount';
import { EVENT_TYPES } from '../HOCs/withEventManager';
import ListItemMerchant from '../components/ListItemMerchant';

function VerifyAccounts(props: TProps): React.Node {
  const {
    public_plaid_account_token,
    accounts,
    merchant,
  } = props.navigation.current.state;
  const verified_accounts = accounts.filter(account => account.is_verified());
  const start_verification = (account: VerifiableAccount) => {
    props.navigateTo('/form', {
      mask: account.mask,
      merchant,
      success_next_path_state: {
        public_plaid_account_token,
        success_next_path: '/verify-accounts',
        success_next_path_state: {
          account_id: account.id,
          accounts,
          merchant,
          public_plaid_account_token,
        },
      },
    });
  };

  const on_continue = () => {
    let public_account_token = null;
    const aggregated_accounts = verified_accounts.map(account => ({
      public_account_token: account.public_account_token,
      mask: account.mask,
    }));

    if (aggregated_accounts.length === 1) {
      public_account_token = aggregated_accounts[0].public_account_token;
    }

    const data = { public_account_token, aggregated_accounts };

    props.dispatchEvent(
      EVENT_TYPES.success,
      data,
      () => props.dispatchEvent(EVENT_TYPES.exit, {}, props.async_delete_link_token),
    );
  };

  return (
    <Layout {...props} showLogo showExit padded>
      <Container mb={16} relative left={-24} width="100vw">
        <ListItemMerchant merchant={merchant} />
      </Container>

      <TextHeader1>
        <TextStrong extra>Verify your identity</TextStrong>
      </TextHeader1>

      <Container height="calc(100vh - 180px)" overflow="scroll" relative left={-24} width="100vw" my={16}>
        {accounts.map(account => (
          <ListItemVerifiableAccount
            key={account.id}
            account={account}
            onClick={start_verification} />
        ))}
      </Container>

      {verified_accounts.length > 0 && (
        <Container absolute bottom={0} left={0} zIndex={100} width="100vw">
          <Container ma={24}>
            <ButtonBlock primary onClick={on_continue}>
              Continue
            </ButtonBlock>
          </Container>
        </Container>
      )}

    </Layout>
  );
}

// $FlowFixMe
export default Sentry.withProfiler(VerifyAccounts, { name: 'VerifyAccounts' });
